

import img1 from './assets/2 copy.jpg';
import img2 from './assets/1 copy.jpg';
import img3 from './assets/5 copy.jpg';

import img4 from './assets/4 copy.jpg';
import img5 from './assets/5 copy.jpg';
import img6 from './assets/6 copy.jpg';
import img7 from './assets/7 copy.jpg';
import img8 from './assets/8 copy.jpg';
import img9 from './assets/9 copy.jpg';
import img10 from './assets/10 copy.jpg';
import img11 from './assets/11 copy.jpg';
import img12 from './assets/12 copy.jpg';
import img13 from './assets/13 copy.jpg';
import img14 from './assets/14 copy.jpg';

import img16 from './assets/16 copy.jpg';
import img17 from './assets/17 copy.jpg';
import img18 from './assets/18 copy.jpg';
import img19 from './assets/19 copy.jpg';
import img20 from './assets/20 copy.jpg';
import img21 from './assets/21 copy.jpg';
import img22 from './assets/22 copy.jpg';
import img23 from './assets/23 copy.jpg';
import img24 from './assets/24 copy.jpg';
import img25 from './assets/25 copy.jpg';
import img26 from './assets/26 copy.jpg';
import img27 from './assets/27 copy.jpg';
import img28 from './assets/28 copy.jpg';
import img30 from './assets/30 copy.jpg';
import img31 from './assets/31 copy.jpg';
import img32 from './assets/32 copy.jpg';
import img33 from './assets/copy33.png';
import img34 from './assets/copy34.png';
export function ImageSlider() {

    const images=[img1,img2,img3,img34,img4,img5, img6, img33,img7, img8, img9, img10, img11, img12, img13, img14,         img16, img17, img18, img19, img20, img21, img22, img23, img24, img25, img26,
        img27, img28, img30,img31,img32];


  return (
    <div className="marquee-container">
      <div className="marquee-track">
        {[...images, ...images].map((src, index) => (
          <div key={index} className="marquee-item">
            <img
              src={src}
              alt={`Product ${index + 1}`}
              className="rounded-lg shadow-lg object-cover"
              width={900}
              height={900}
              priority={index < 40} // Prioritize loading first few images
            />
          </div>
        ))}
      </div>
    </div>
  )
}
export default ImageSlider;
